<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container v-if="item"
                 v-bind:class="[{ busy: item.id === busyItemId }, 'article-row-card', 'opacity-transition', 'mb-2']">
        <pb-spinner v-if="item.id === busyItemId"></pb-spinner>
        <b-row class="content p-3">
            <b-col md="2" class="m-auto">
                <div class="image d-flex">
                    <img @error="$event.target.style.display='none'" class="card-img-top"
                         :src="imageResource(thumbnail, 200)" alt="image"/>
                </div>
            </b-col>
            <b-col md="10">
                <b-row class="article-subtitle">
                    <b-col>
                        {{item.articleDetails.name}}&nbsp;&nbsp;<span v-if="customerArticleNumber">|&nbsp;&nbsp;{{customerArticleNumber}}</span>
                    </b-col>
                </b-row>
                <b-row class="article-title mt-2">
                    <b-col>
                        {{item.articleDetails.primaryDescription ||
                        item.articleDetails.secondaryDescription}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                            class="article-subtitle">Size: {{selectedSize.value}}|&nbsp;&nbsp;Color: {{selectedColor.value}}</span>
                    </b-col>
                </b-row>
                <b-row class="mt-3" align-v="center">
                    <b-col cols="auto" class="text-right">
                        <label for="amount">Amount:</label>
                    </b-col>
                    <b-col md="2">
                        <b-form-spinbutton
                                id="amount"
                                v-model="amount"
                                min="1"
                                class="secondary"
                                max="5"
                                step="1"
                        ></b-form-spinbutton>
                    </b-col>
                    <b-col cols="auto">
                        <label for="comment">Comment:</label>
                    </b-col>
                    <b-col>
                        <b-form-input
                                id="comment"
                                name="comment"
                                class="h-auto secondary"
                                v-model.trim="comment"
                                placeholder="Alternative finish or size, comment"
                                no-resize
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col class="text-right">
                        <b-button @click="removeSample({item: item})" variant="link"><i
                                class="fal fa-times fa-inline"></i>
                            REMOVE
                        </b-button>
                        <b-button variant="primary" class="ml-2" @click="update()">
                            SAVE
                        </b-button>

                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>


    import {mapActions, mapState} from "vuex";
    import ArticleBase from "../Article/ArticleBase";

    export default {
        name: 'sample-overview-item',
        extends: ArticleBase,
        props: {
            item: Object
        },
        components: {},
        data() {
            return {
                selectedColor: null,
                selectedSize: null,
                comment: this.item.comment,
                amount: this.item.amount
            };
        },
        created() {
            let variant = this.variantList.find(variation => {
                return variation.variationId === this.item.variantId;
            });

            this.selectedColor = variant.articleColor;
            this.selectedSize = variant.articleSize;

        },
        methods: {
            ...mapActions('sample', ['removeSample', 'updateItem']),
            update() {
                this.item.comment = this.comment;
                this.item.amount = this.amount;
                this.updateItem({
                    item: this.item
                }).then(() => {
                    this.$bvToast.toast(`Item was successfully updated.`, this.$toastSuccess)
                })
            }
        },
        computed: {
            ...mapState("sample", ['busyItemId']),
            article: function () {
                return this.item.articleDetails;
            },
            thumbnail: function () {
                let variant = this.variantList.find(variation => {
                    return variation.variationId == this.item.variantId;
                });

                let variantThumbnail = this.getThumbnail(variant.articleSize.id, variant.articleColor.id);
                return variantThumbnail ? variantThumbnail.media : (this.article.webImage || this.article.image);
            },
            articleDetails: function () {
                return this.item.articleDetails;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

</style>
